import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { matchPath } from 'react-router'
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import ReactHtmlParser from 'react-html-parser';

//actions
import { getMetaTags } from 'redux/actions';

//routing constants
import * as routes from 'constants/routes';

class Meta extends Component {

    shouldComponentUpdate(nextProps) {
        let new_path = nextProps.location.pathname !== this.props.location.pathname;
        let new_tags = nextProps.Tags !== this.props.Tags;
        return new_path || new_tags;
    }

    componentDidMount() {
        this.requestTags();
    }

    componentDidUpdate() {
        this.requestTags();
    }

    requestTags() {
        let payload = {};
        let route_name = this.getRoute();
        let cached = false;
        payload.route = route_name;

        //change payload according to route name.
        //content pages and benefit pages have objectIds to consider
        switch (route_name) {
            case 'contents':
                payload.objectId = this.getContentId();
                if (this.props.Tags) {
                    cached = this.props.Tags.route.includes(payload.objectId);
                }
                break;
            case 'car':
                payload.objectId = this.getCarId();
                if (this.props.Tags) {
                    cached = this.props.Tags.route.includes(payload.objectId);
                }
                break;
            default:
                if (this.props.Tags) {
                    console.log(this.props.Tags.route.includes(route_name));
                    cached = this.props.Tags.route.includes(route_name) && this.props.Tags.hasOwnProperty('val');
                }
        }

        if (!cached) {
            this.props.getMetaTags(payload);
        }

    }

    getContentId() {
        let objectId = '';
        for(let key in this.props.ContentPages) {
            let contentPage = this.props.ContentPages[key];
            if(('/' + key) === this.props.location.pathname) {
                objectId = contentPage;
            }
        }
        return objectId;
    }

    getRoute() {
        let route_name = '';
        for(let route in routes) {
            if(routes[route] === this.props.location.pathname) {
                route_name = route;
            }
        }
        if(route_name === 'root') route_name = 'home';
        if(this.props.location.pathname.includes(routes.car)) route_name = 'car';
        if(route_name === '') route_name = 'contents';
        return route_name;
    }

    getExtraTags(data) {

        let tags = [];
        data.forEach((item) => {
            tags.push(ReactHtmlParser(item));
        });

        return tags;
    }

    getCarId() {
        const match = matchPath(this.props.history.location.pathname, {
            path: routes.car + '/:licenseNumber',
            exact: false,
            strict: false
        });
        return match.params.licenseNumber.split('=')[1];
    }


    render() {
        const data = this.props.Tags.val;

        let metaTagsArr = [];
        if(data) {
            for(let key in data.meta_tags) {
                metaTagsArr.push(
                    <meta name={ key } content= { data.meta_tags[key] } key={ key } />
                );

                if (key === 'description' || key === 'title'){
                    metaTagsArr.push(
                        <meta property={"og:" + key} content= { data.meta_tags[key] } key={ key + 'og' } />
                    );
                }
            };
        }

        return (
            <Fragment>
                <MetaTags>
                    { data &&
                    <Fragment>
                        { metaTagsArr }
                        <title>{ data.meta_tags['title'] }</title>
                        { this.getExtraTags(data.extra_tags) }
                    </Fragment>
                    }
                </MetaTags>
            </Fragment>
        )
    }
}

const mapStateToProps = store => {
    return {
        Tags: store.data.Tags,
        ContentPages: store.config.RouteTable,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        getMetaTags: (payload) => dispatch(getMetaTags(payload)),
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Meta));